import { computed, ref } from "vue"
import { useTenantStore } from "/@/kernel-mn/stores/tenant";
import { useEnhancer } from "/@/plugins/enhancer";
import { G_goLogin } from '/@/plugins/public_utils';
import { useHot } from "/@/kernel-mn/stores/useHot";
import { isAndroid, isApp, isIOS } from '/@/kernel-mn/utils';
import { mb_RNEvent } from "/@/plugins/global";

export const useBottomSwiper = () => {
  const redPackRef = ref(null)

  const tenantState = useTenantStore();
  const { router } = useEnhancer();
  const { hotData: { isLogined, tenantInfo }, activeConfiguration } = useHot();

  const rightBottomIcon = computed(() => {
    // console.log('rightBottomIcon:',tenantState.sideMenu.rightDown)
    return tenantState.sideMenu.rightDown
  })

  const onAffixItemClick = (item, num) => {
    // console.log('onAffixItemClick:', item, num)
    /*
    未处理 // 40：好友 ？// 41：转帐 ？ 15: 聊天室？
    */
    if (item?.link_name?.includes('open_in_browser=true')) {
      window.open(item.link_name);
      return false;
    }
    if (Number(item.link) === 2) {
      // 1:内部链接 2:外部链接
      if (Number(item.oper_method) === 1) {
        window.open(item.link_name);
      } else {
        router.push(item.link_name);
      }
    } else {
      let code = Number(item.slideshow_code);
      if (code === 5 || code === 44 || code === 46 || code === 50 || code === 51 || code === 49) {
        // 44：客服微信 ？// 46：客服电话// 50：安卓下载 ？// 51：苹果下载 ?// 活动申请
        if (code === 50 || code === 51 || code === 5) {
          // router.push('/download')
          toLoad(code);
        } else if (code === 49) {
          router.push('/task?type=0');
        } else if (code === 44) {
          router.push('/service?index=2');
        } else if (code === 46) {
          router.push('/service?index=4');
        }
      } else if (code === 89) {
        // 活动申请
        router.push('/task?type=0');
      } else if (code === 15) {
        router.push('/chatlist');
      } else if (code === 17) {
        router.push('/task?type=1'); // 任务
      } else if (code === 18) {
        // 优惠活动
        router.push('/task?type=0');
      } else if (code === 19 || code === 40 || code === 41) {
        // 19:红包雨 ？ 40：好友 ？// 41：转账 ？
        if (!isLogined.value) {
          G_goLogin();
        } else if (isLogined.value) {
          if (code === 19) {
            redPackRef.value.redpack.setShow(true);
          } else if (code === 40) {
            router.push('/chatlist');
          } else if (code === 41) {
            router.push('/friendsExchange');
          }
        }
      } else if (code === 56) {
        // 56：免费试玩
        if (isLogined.value) {
          return;
        }
      } else if (code === 220) {
        if (isLogined.value) {
          router.push('/favorite');
        } else {
          G_goLogin();
        }
      } else if (code === 1) {
        if (isLogined.value) {
          router.push('/mine');
        } else {
          G_goLogin();
        }
      } else if (code === 2) {
        // 充值
        if (!isLogined.value) {
          G_goLogin();
        } else {
          router.push('/recharge?from=home');
        }
      } else if (code === 59) {
        // 有玩就有礼 - 活动
        router.push('/task?type=1&taskType=102');
      } else if (code === 61) {
        // 分享领工资
        router.push('/task?type=1&taskType=106');
      } else if (code === 62) {
        // 亏损救援金
        router.push('/task?type=1&taskType=103');
      } else if (code === 63) {
        // 虚拟币活动
        router.push('/task?type=1&taskType=111');
      } else if (code === 67) {
        // 游戏任务
        router.push('/task?type=1&taskType=110');
      } else if (code === 68) {
        // 会员任务
        router.push('/task?type=1&taskType=112');
      } else if (code === 70) {
        // 活动奖金
        if (!activeConfiguration.value['50']) {
          // this.$vux.toast.show({ text: this.$t('当前暂无活动') });
          return;
        }
        if (isLogined.value) {
          router.push('/task?type=1&taskType=113');
        } else {
          G_goLogin();
        }
      } else if (code === 64) {
        // 答题赢彩金
        if (!isLogined.value) {
          G_goLogin();
        }
      } else if (code === 65) {
        // 幸运注单
        if (!isLogined.value) {
          G_goLogin();
        } else {
          router.push('/luckNote');
        }
      } else if (code === 66) {
        // 充值大礼包
        if (!isLogined.value) {
          G_goLogin();
        } else {
          router.push('/task?type=1&taskType=101');
        }
      } else if (code === 69) {
        // 幸运大转盘
        if (!isLogined.value) {
          G_goLogin();
        } else {
          router.push('/xydzp');
        }
      } else if (code === 3) {
        // 提现
        if (!isLogined.value) {
          G_goLogin();
        } else {
          router.push('/withdrawadd');
        }
      } else if (code === 5) {
        // APP下载
        // if (!isLogined.value) {
        //   this.getLink(true);
        // } else if (this.isFreeUser || this.userInfo.fict_flag) {
        //   router.push('/download');
        // } else {
        //   router.push('/download');
        // }
      } else if (code === 22) {
        if (isLogined.value) {
          router.push('/backupWebsites');
        } else {
          router.push('/backupWebsites');
        }
      } else if (code === 57) {
        // 彩票大厅
        router.push('/qipai?tab=0&qipaiTab=0');
      } else if (code === 58 || code === 165 || code === 170 || code === 399) {
        // 捕鱼大厅
        router.push('/qipai?tab=4&qipaiTab=0');
      } else if (code === 172) {
        router.push('/qipai?tab=1&qipaiTab=1');
      } else if (code === 108) {
        // 开元棋牌
        router.push('/qipai?tab=1&qipaiTab=1');
      } else if (code === 164) {
        // FG电子大厅
      } else if (code === 166) {
        // FG棋牌大厅
      } else if (code === 223) {
        // PG电子新
        router.push('/game?key=electronic&upper_play_id=1380');
      } else if (code === 224) {
        // PG2电子
        router.push('/game?key=electronic&upper_play_id=1382');
      } else if (code === 225) {
        // DB电子 浮动图
        router.push('/game?key=electronic&upper_play_id=1383');
      } else if (
        [
          107, 108, 109, 111, 113, 114, 115, 116, 118, 119, 120, 121, 122, 123, 124, 125, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 138, 137, 140, 141, 142, 143, 145, 146, 147, 148, 149,
          151, 152, 154, 155, 156, 157, 158, 161, 171, 197, 219
        ].includes(code)
      ) {
        router.push('/game?key=electronic')
      } else {
        if (code === 4 || code === 6 || code === 7) {
          if (code === 4) {
            // window.open(this.tService);
          } else if (code === 6) {
            // 活动中心
            router.push('/task?mode=subPage');
          } else if (code === 7) {
            // 帮助中心
            // router.push('/helpCenter');
          }
          return;
        } else if (code === 43 || code === 45 || code === 48 || code === 49 || code === 52 || code === 53) {
          if (code === 43) {
            // 客服QQ
          } else if (code === 53) {
            // 活动申请
          } else if (code === 45) {
            // 代理QQ
          } else if (code === 52) {
            // 52：官网地址
          }
          return;
        }
        // if (playInfo[code]) {
        //   let play = this.config.getPlayInfo(playInfo[code]);
        //   if (play) {
        //     let that = this;
        //     if (play.cat === 'AG' || play.cat === 'TY') {
        //       if (playInfo[code] === 706 || playInfo[code] === 710) {
        //         that.leftClose();
        //       }
        //       if (playInfo[code] === 490) {
        //         that.leftClose();
        //         that.kuaiJieClose();
        //         router.push('/qipai?tab=5&qipaiTab=0');
        //         return;
        //       }
        //       if (!isLogined.value) {
        //         if (play.cat === 'AG') {
        //           router.push('/qipai?tab=2&dzTab=0');
        //         } else {
        //           router.push('/qipai?tab=5&qipaiTab=0');
        //         }
        //         return;
        //       }
        //       // IM 体育
        //       if (+playInfo[code] === 931) {
        //         if (!isLogined.value) {
        //           router.replace('/login');
        //           return false;
        //         }
        //         router.push('/sport');
        //         return false;
        //       }
        //       !this.utils.isApp() && (this.newTab = window.open('about:blank'));
        //       this.checking3Game({
        //         play_id: playInfo[code],
        //         callback(res, err) {
        //           if (err) {
        //             !that.utils.isApp() && that.newTab.close();
        //             if (err.exMessage) {
        //               // that.$vux.toast.show(err.info)
        //               that.$t(err.info);
        //             } else if (err.info) {
        //               // that.$vux.toast.show(err.info.toString())
        //               that.$t(err.info);
        //             }
        //           } else if (res.response_code && res.response_code === '9999') {
        //             that.playGame(play, playInfo[code]);
        //           }
        //         }
        //       });
        //     } else if (play.cat === 'DZ') {
        //       const dzTab = this.gameBigClass.electronic.findIndex(i => i.play_id === playInfo[code]);
        //       router.push(`/qipai?tab=3&dzTab=${dzTab}&playId=${playInfo[code]}`);
        //     } else if (play.cat === 'QP') {
        //       const dzTab = this.gameBigClass.chessList.findIndex(i => i.play_id === playInfo[code]);
        //       router.push(`/qipai?tab=1&dzTab=${Number(dzTab) + 1}`);
        //     }
        //   }
        // }
        if (!isLogined.value) {
          G_goLogin();
          return;
        }
        switch (code) {
          case 8: // 签到
            router.push('/mine');
            break;
          case 9: // 余额宝
            router.push('/yeb');
            break;
          case 10: // 借呗
            router.push('/borrow');
            break;
          case 11: // 自助返水
            router.push('/selfrebate');
            break;
          case 12: // 站内信
            router.push('/message');
            break;
          case 13: // 备注
            router.push('/mine');
            break;
          case 14: // 账号交易
            router.push('/mine');
            break;
          case 15: // 聊天室
            // handleNavItemCommon.bind(this)(navbars['chat'])
            break;
          case 16: // 代理中心
            router.push('/agentSystem');
            break;
          case 20: // 等级中心
            router.push('/vippromotion?mode=subPage');
            break;
          case 21: // 我的分享
            router.push('/myshare');
            break;
          case 39: // 全民推广
            router.push('/promotion');
            break;
          case 38: // 38：我的佣金
            router.push('/myCommission');
            break;
          case 42: // 我的投注
            router.push('/touzhuList');
            break;
          case 47: // 47：投诉建议
            // router.push('/news?flag=5');
            break;
          case 54: // 长龙助手 longDragon
            // router.push('/longDragon?type=1');
            break;
          // case 56: // 免费试玩
          // 	break
          case 55: // 会员中心
            router.push('/mine');
            break;
        }
      }
    }
  };

  const toLoad = code => {
    if (tenantInfo.value.tenant && (tenantInfo.value.tenant.app_reg_addr || tenantInfo.value.tenant.official_addr)) {
      let url = '';
      switch (code) {
        case 5:
          if (isIOS()) {
            url = tenantInfo.value.tenant.app_reg_addr;
          } else {
            url = tenantInfo.value.tenant.official_addr;
          }
          break;
        case 50:
          url = tenantInfo.value.tenant.official_addr;
          break;
        case 51:
          url = tenantInfo.value.tenant.app_reg_addr;
          break;
      }
      if (isApp() && isAndroid()) {
        mb_RNEvent.sendNativeMsg('url:' + url);
      } else {
        window.open(url);
      }
    }
  };

  const formatOutLinkData = link => {
    const linkArray = link.split('&');
    return {
      url: linkArray[0],
      name: linkArray[1] || linkArray[0]
    };
  };

  return {
    rightBottomIcon,
    onAffixItemClick,
    formatOutLinkData,
    redPackRef
  }
}